import React from "react";
import "../css/AfterHoursCard.css";
import rightArrow from "../../../assets/images/right_arrow_icon.svg";
import { getTimezoneString } from "../../../utils/dateUtils";

const AfterHoursCard = ({
  departureTimings,
  arrivalTimings,
  departureAirport,
  arrivalAirport,
  onClick,
}) => {
  return (
    <div className="trip-details-after-hours-card" onClick={onClick}>
      <div className="trip-details-card-content">
        <h2 className="trip-details-card-title">After Hours Requested</h2>
        {departureTimings && (
          <p className="trip-details-card-timings" data-testid="departure-timings">
            {departureAirport} • Timings: {departureTimings} ({getTimezoneString()})
          </p>
        )}
        {arrivalTimings && (
          <p className="trip-details-card-timings" data-testid="arrival-timings">
            {arrivalAirport} • Timings: {arrivalTimings} ({getTimezoneString()})
          </p>
        )}
      </div>
      <div className="trip-details-card-arrow">
        <img src={rightArrow} alt="rightArrow" />
      </div>
    </div>
  );
};

export default AfterHoursCard;
